// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',

    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      }
    ]
  },
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '浅集云码' },
    redirect: '/dashboard',
    children: [
      // 首页
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Index'),
        meta: { title: '首页', icon: 'desktop', hiddenPageTitle: true, keepAlive: true }
      },
      // 客户管理
      {
        path: '/tenant',
        name: 'tenant',
        component: () => import('@/views/tenant/Index'),
        meta: { title: '客户管理', icon: 'shop', hiddenPageTitle: true, keepAlive: true }
      },
      // 订单管理
      {
        path: '/order',
        name: 'order',
        component: PageView,
        meta: { title: '订单管理', icon: 'container', hiddenPageTitle: true, keepAlive: true, permission: ['form'] },
        hideChildrenInMenu: false,
        children: [
          {
            path: '/order/recharge',
            name: 'recharge',
            component: () => import('@/views/order/recharge'),
            meta: { title: '充值订单', keepAlive: true }
          },
          {
            path: '/order/annual',
            name: 'annual',
            component: () => import('@/views/order/annual'),
            meta: { title: '年费订单', keepAlive: true }
          },
          {
            path: '/order/printing',
            name: 'printing',
            component: () => import('@/views/order/printing'),
            meta: { title: '打印订单', keepAlive: true }
            // redirect: '/order/operation'
            // hideChildrenInMenu: true,
            // children: [
            //   {
            //     path: '/order/operation/detail',
            //     name: 'detail',
            //     component: () => import('@/views/order/operation/detail'),
            //     meta: { title: '订单详情', keepAlive: true, permission: ['user'] }
            //   },
            //   {
            //     path: '/order/operation/output',
            //     name: 'output',
            //     component: () => import('@/views/order/operation/output'),
            //     meta: { title: '打印云码', keepAlive: true, permission: ['user'] }
            //   }
            // ]
          }
        ]
      },
      // 订单管理
      {
        path: '/programme',
        name: 'programme',
        component: PageView,
        meta: { title: '方案管理', icon: 'appstore', hiddenPageTitle: true, keepAlive: true, permission: ['form'] },
        hideChildrenInMenu: false,
        children: [
          {
            path: '/programme/code',
            name: 'code',
            component: () => import('@/views/programme/code'),
            meta: { title: '云码支付方案', keepAlive: true }
          },
          {
            path: '/programme/printing',
            name: 'print',
            component: () => import('@/views/programme/printing'),
            meta: { title: '打印支付方案', keepAlive: true }
          }
        ]
      },
      // 提现管理
      {
        path: '/withdrawal',
        name: 'withdrawal',
        component: () => import('@/views/withdrawal/Index'),
        meta: { title: '提现管理', icon: 'pay-circle', hiddenPageTitle: true, keepAlive: true }
      },
      // 数据库管理
      {
        path: '/database',
        name: 'database',
        component: () => import('@/views/database/Index'),
        meta: { title: '数据库管理', icon: 'database', hiddenPageTitle: true, keepAlive: true }
      },
      // 系统设置
      {
        path: '/system',
        name: 'system',
        // component: () => import('@/views/system/Index'),
        component: PageView,
        meta: { title: '系统管理', icon: 'setting', permission: ['form'] },
        redirect: '/system/base',
        hideChildrenInMenu: false,
        children: [
          {
            path: '/system/base',
            name: 'base',
            component: () => import('@/views/system/base/Setting'),
            meta: { title: '系统设置', keepAlive: true, permission: ['user'] },
            redirect: '/system/base/info',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/system/base/info',
                name: 'Info',
                component: () => import('@/views/system/base/Info'),
                meta: { title: '系统配置', keepAlive: true, permission: ['user'] }
              },
              {
                path: '/system/base/rds',
                name: 'Rds',
                component: () => import('@/views/system/base/Rds'),
                meta: { title: '阿里云RDS配置', keepAlive: true, permission: ['user'] }
              },
              {
                path: '/system/base/oss',
                name: 'Oss',
                component: () => import('@/views/system/base/Oss'),
                meta: { title: '阿里云OSS配置', keepAlive: true, permission: ['user'] }
              },
              {
                path: '/system/base/wechat',
                name: 'Wechat',
                component: () => import('@/views/system/base/Wechat'),
                meta: { title: '微信公众号配置', keepAlive: true, permission: ['user'] }
              },
              {
                path: '/system/base/Sms',
                name: 'Sms',
                component: () => import('@/views/system/base/Sms'),
                meta: { title: '短信配置', keepAlive: true, permission: ['user'] }
              }
            ]
          },
          {
            path: '/system/role',
            name: 'role',
            component: () => import('@/views/system/Role'),
            meta: { title: '角色管理', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/system/admin',
            name: 'admin',
            component: () => import('@/views/system/Admin'),
            meta: { title: '用户管理', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/system/pay',
            name: 'pay',
            component: () => import('@/views/system/pay/Setting'),
            meta: { title: '支付配置', hideHeader: true, permission: ['user'] },
            redirect: '/system/pay/wxpay',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/system/pay/wxpay',
                name: 'WxAppPay',
                component: () => import('@/views/system/pay/WxPay'),
                meta: { title: '微信扫码支付', keepAlive: true, permission: ['user'] }
              },
              {
                path: '/system/pay/alipay',
                name: 'Alipay',
                component: () => import('@/views/system/pay/Alipay'),
                meta: { title: '支付宝扫码支付', keepAlive: true, permission: ['user'] }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
